import { Routes } from "./../../../enums/routes.enum";
import { MazeedRoutes } from "./../../../enums/mazeed/mazeed.routes";
import { PermissionsSlugs } from "./../../../enums/permissions.enum";
import { ToolsRoutes } from "@/enums/tools/tools.routes";

export const linksData = [
  {
    label: "users",
    destination: Routes.users,
    permissions: [PermissionsSlugs.canViewUsers],
    icon: "group",
  },
  {
    label: "roles",
    destination: Routes.roles,
    permissions: [PermissionsSlugs.canViewRoles],
    icon: "lock_open",
  },
  {
    label: "merchants",
    destination: Routes.merchants,
    permissions: [PermissionsSlugs.canViewMerchants],
    icon: "store",
  },
  {
    label: "purchasesGroup",
    destination: Routes.purchases,
    permissions: [
      PermissionsSlugs.canViewPendingPurchasesAsCS,
      PermissionsSlugs.canViewPendingPurchasesAsFinance,
    ],
    icon: "shopping_cart",
    children: [
      {
        label: "list",
        destination: Routes.purchases,
        permissions: [
          PermissionsSlugs.canViewPendingPurchasesAsCS,
          PermissionsSlugs.canViewPendingPurchasesAsFinance,
        ],
        icon: "contract",
      },
      {
        label: "create",
        destination: Routes.purchaseCreate,
        permissions: [],
        icon: "add_circle",
      },
    ],
  },
  {
    label: "eliteContractGroup",
    destination: Routes.contracts,
    permissions: [],
    icon: "handshake",
    children: [
      {
        label: "list",
        destination: Routes.contracts,
        permissions: [],
        icon: "contract",
      },
      {
        label: "create",
        destination: Routes.enterprisePurchaseCreate,
        permissions: [],
        icon: "add_circle",
      },
    ],
  },
  {
    label: "paymentLinks",
    destination: Routes.paymentLinks,
    permissions: [],
    icon: "payment_arrow_down",
  },
  {
    label: "countries",
    destination: Routes.countries,
    permissions: [PermissionsSlugs.canViewCountries],
    icon: "language",
  },
  {
    label: "themes",
    destination: Routes.themes,
    permissions: [PermissionsSlugs.canViewThemes],
    icon: "palette",
  },
  {
    label: "offers",
    destination: Routes.offers,
    permissions: [PermissionsSlugs.canViewOffersCoupons],
    icon: "sell",
  },
  {
    label: "packages",
    destination: Routes.packages,
    permissions: [PermissionsSlugs.canViewCorePackages],
    icon: "inventory_2",
  },
  {
    label: "products",
    destination: Routes.products,
    permissions: [PermissionsSlugs.canViewProducts],
    icon: "layers",
  },
  {
    label: "coupons",
    destination: Routes.coupons,
    permissions: [PermissionsSlugs.canViewOffersCoupons],
    icon: "redeem",
  },
  {
    label: "oneTimeOffers",
    destination: Routes.oneTimeOffersList,
    permissions: [PermissionsSlugs.canManageOneTimeOffers],
    icon: "hand_package",
  },
  {
    label: "campaignSenders",
    destination: Routes.campaignSenders,
    permissions: [],
    icon: "sms",
  },
  {
    label: "smsProviderTools",
    destination: Routes.sms,
    permissions: [],
    anyPermissions: [
      PermissionsSlugs.canViewSmsProviderSettings,
      PermissionsSlugs.canManageSmsProviderSettings,
      PermissionsSlugs.canManageLegacySmsProviderSettings,
    ],
    icon: "settings_phone",
  },
  {
    label: "log",
    destination: Routes.log,
    permissions: [],
    icon: "receipt_long",
  },
  {
    label: "wallet",
    destination: Routes.wallet,
    permissions: [],
    icon: "account_balance_wallet",
  },
  {
    label: "RMS (Hubspot)",
    destination:
      "https://app.hubspot.com/contacts/4731529/objects/0-5/views/all/board",
    permissions: [],
    icon: "hub",
    isExternal: true,
  },
  {
    label: "marketplace",
    destination: Routes.marketplace,
    permissions: [PermissionsSlugs.canManageCommissions],
    icon: "add_business",
  },
  {
    label: "latestFeatures.latestFeatures",
    destination: Routes.latestFeatures,
    permissions: [],
    icon: "new_releases",
  },
  {
    label: "Mazeed",
    destination: Routes.mazeed,
    permissions: [],
    icon: "more_horiz",
    children: [
      {
        label: "categories",
        destination: MazeedRoutes.categoriesList,
        permissions: [PermissionsSlugs.canViewMazeedCategories],
        icon: "category",
      },
      {
        label: "merchants",
        destination: MazeedRoutes.storesList,
        permissions: [PermissionsSlugs.canViewMazeedStores],
        icon: "storefront",
      },
      {
        label: "products",
        destination: MazeedRoutes.productsList,
        permissions: [PermissionsSlugs.canViewMazeedProducts],
        icon: "conveyor_belt",
      },
      {
        label: "orders",
        destination: MazeedRoutes.ordersList,
        permissions: [PermissionsSlugs.canViewMazeedOrders],
        icon: "order_approve",
      },
      {
        label: "banners",
        destination: MazeedRoutes.bannersList,
        permissions: [PermissionsSlugs.canViewMazeedBanners],
        icon: "planner_banner_ad_pt",
      },
      {
        label: "coupons",
        destination: MazeedRoutes.couponsList,
        permissions: [PermissionsSlugs.canViewMazeedCoupons],
        icon: "redeem",
      },
      {
        label: "settlements",
        destination: MazeedRoutes.settlementsList,
        permissions: [PermissionsSlugs.canViewMazeedSettlements],
        icon: "request_quote",
      },
      {
        label: "customers",
        destination: MazeedRoutes.customersList,
        permissions: [PermissionsSlugs.canViewCustomers],
        icon: "settings_accessibility",
      },
      {
        label: "collection",
        destination: MazeedRoutes.discoverCollectionListing,
        permissions: [],
        icon: "apps",
      },
      {
        label: "section",
        destination: MazeedRoutes.discoverSectionListing,
        permissions: [],
        icon: "segment",
      },
      {
        label: "tags",
        destination: MazeedRoutes.tagsList,
        permissions: [],
        icon: "bookmarks",
      },
    ],
  },
  {
    label: "Tools",
    destination: Routes.tools,
    permissions: [],
    icon: "handyman",
    children: [
      {
        label: "ZAM",
        destination: ToolsRoutes.zam,
        permissions: [PermissionsSlugs.canUseZamTools],
        icon: "widgets",
      },
      {
        label: "Switchers",
        destination: ToolsRoutes.switchers,
        permissions: [PermissionsSlugs.canUseSwitcherTools],
        icon: "widgets",
      },
      {
        label: "Subscriptions",
        destination: ToolsRoutes.subscriptions,
        permissions: [PermissionsSlugs.canUseSubscriptionTools],
        icon: "widgets",
      },
      {
        label: "EraseCustomer",
        destination: ToolsRoutes.eraseCustomer,
        permissions: [PermissionsSlugs.canEraseCustomer],
        icon: "person_remove",
      },
    ],
  },
];
